import {axiosInstance} from './axios';

export async function uplodeImage(base64) {
  console.log('sss')
  try {
    return await axiosInstance.post(`/api/v1/upload-img`,{img:base64})
  }catch (e) {
    return null;
  }
}
